<template>
        <v-flex >
          <v-toolbar flat class="mx-auto mb-4">
            <v-btn icon v-on:click.native="goBack()" >
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title class="headline">{{msg}}</v-toolbar-title>
          </v-toolbar>
          <v-flex  mx-auto>
            <voice-date-select ></voice-date-select>
			<sick></sick>
            <voice-data-table postType='Pitch'></voice-data-table>
            <div class="text-xs-center mt-4">
            <v-btn round color="primary" to="/val">Add Activity</v-btn>
            </div>  
          </v-flex>
        </v-flex>
</template>

<script>

import DateSelect from '../DateSelect.vue'
import ValDataTable from '../val/ValDataTable.vue'
import DeleteActivityMutation from '../mutations/DeleteActivityMutation';
import GetActivityByUserQuery from '../queries/GetActivityByUserQuery';
import VocalActivityHome from '../home/VocalActivityHome.vue'
import Sick from '../home/Sick.vue'

export default {
	data () {
		return {
			msg: 'Voice Pitch Ceiling Log',
			DeleteActivityMutation: DeleteActivityMutation,
			switch1: (localStorage.sickMarkerValue=='true'),
			vocalActivityValue: localStorage.vocalActivityTotal,
			totalDailyAllotment: localStorage.totalDailyAllotment,
			GetActivityByUserQuery: GetActivityByUserQuery,
		}
	},
	components: {
		'voice-date-select': DateSelect,
		'voice-data-table': ValDataTable,
		'vocal-activity-home': VocalActivityHome,
		'sick': Sick,
	},
	methods: {
		goBack(){ this.$router.back(); },
      
		calActVal(){
			var temp=Math.floor((localStorage.vocalActivityTotal/localStorage.totalDailyAllotment) * 100);
			if(isNaN(temp) || !isFinite(temp)){temp=0;}
			return temp;
		},
	}
  
}
</script>





// WEBPACK FOOTER //
// src/components/settings/PitchDetails.vue